<template>
  <div class="docs">
    <ui-title :title="t('docs.terms.title')" :wave="'/docsTitleBg.png'" />
    <div class="docs__wrapper">
      <docs-navigation
          ref="navRef"
          :list="navigationList"
          @navigate="scrollToSection"
          :active-section="activeSection"
      />
      <el-scrollbar
          ref="scrollbarRef"
          always
          class="docs__main"
          @scroll="handleScroll"
      >
        <div
            v-for="(content, idx) of terms"
            :key="idx"
            class="docs__main-block"
            :id="`section-${idx}`"
            ref="sectionsRef"
        >
          <h2 class="docs__main-title" v-if="content.title">{{ t(`docs.terms.content[${idx}].title`) }}</h2>
          <i18n-t
              class="docs__main-text"
              v-if="content.text1"
              scope="global"
              tag="p"
              :keypath="`docs.terms.content[${idx}].text1`"
          >
            <template #domain>
              <router-link :to="translations.i18nRoute({ name: 'home' })">findprotemplates.com</router-link>
            </template>
            <template #email>
              <a :href="'mailto:' + companyEmail" class="rules__link">{{ companyEmail }}</a>
            </template>
            <template #companyName>
              <span>{{ companyName }}</span>
            </template>
            <template #companyAddress>
              <span>{{ companyAddress }}</span>
            </template>
            <template #companyNumber>
              <span>{{ companyNumber }}</span>
            </template>
          </i18n-t>
          <i18n-t
              class="docs__main-text"
              v-if="content.text2"
              scope="global"
              tag="p"
              :keypath="`docs.terms.content[${idx}].text2`"
          >
            <template #domain>
              <router-link :to="translations.i18nRoute({ name: 'home' })">findprotemplates.com</router-link>
            </template>
          </i18n-t>
          <ul v-if="content.list2">
            <i18n-t
                class="docs__main-text"
                scope="global"
                tag="li"
                v-for="(list2Item, list2Idx) in content.list2"
                :key="list2Idx"
                :keypath="`docs.terms.content[${idx}].list2[${list2Idx}].text`"
            >
              <template #domain>
                <router-link :to="translations.i18nRoute({ name: 'home' })">findprotemplates.com</router-link>
              </template>
              <template #domainUpp>
                <router-link :to="translations.i18nRoute({ name: 'home' })">Findprotemplates.com</router-link>
              </template>
              <template #email>
                <a :href="'mailto:' + companyEmail" class="rules__link">{{ companyEmail }}</a>
              </template>
              <template #companyName>
                <span>{{ companyName }}</span>
              </template>
              <template #companyAddress>
                <span>{{ companyAddress }}</span>
              </template>
              <template #companyNumber>
                <span>{{ companyNumber }}</span>
              </template>
            </i18n-t>
          </ul>
          <i18n-t
              class="docs__main-text"
              v-if="content.text3"
              scope="global"
              tag="p"
              :keypath="`docs.terms.content[${idx}].text3`"
          >
            <template #domain>
              <router-link :to="translations.i18nRoute({ name: 'home' })">findprotemplates.com</router-link>
            </template>
            <template #domainUpp>
              <router-link :to="translations.i18nRoute({ name: 'home' })">Findprotemplates.com</router-link>
            </template>
            <template #email>
              <a :href="'mailto:' + companyEmail" class="rules__link">{{ companyEmail }}</a>
            </template>
            <template #companyName>
              <span>{{ companyName }}</span>
            </template>
            <template #companyAddress>
              <span>{{ companyAddress }}</span>
            </template>
            <template #companyNumber>
              <span>{{ companyNumber }}</span>
            </template>
          </i18n-t>
          <ul v-if="content.list3">
            <i18n-t
                class="docs__main-text"
                scope="global"
                tag="li"
                v-for="(list3Item, list3Idx) in content.list3"
                :key="list3Idx"
                :keypath="`docs.terms.content[${idx}].list3[${list3Idx}].text`"
            >
              <template #domain>
                <router-link :to="translations.i18nRoute({ name: 'home' })">findprotemplates.com</router-link>
              </template>
              <template #domainUpp>
                <router-link :to="translations.i18nRoute({ name: 'home' })">Findprotemplates.com</router-link>
              </template>
              <template #email>
                <a :href="'mailto:' + companyEmail" class="rules__link">{{ companyEmail }}</a>
              </template>
              <template #companyName>
                <span>{{ companyName }}</span>
              </template>
              <template #companyAddress>
                <span>{{ companyAddress }}</span>
              </template>
              <template #companyNumber>
                <span>{{ companyNumber }}</span>
              </template>
            </i18n-t>
          </ul>
          <i18n-t
              class="docs__main-text"
              v-if="content.text4"
              scope="global"
              tag="p"
              :keypath="`docs.terms.content[${idx}].text4`"
          >
            <template #domain>
              <router-link :to="translations.i18nRoute({ name: 'home' })">findprotemplates.com</router-link>
            </template>
            <template #domainUpp>
              <router-link :to="translations.i18nRoute({ name: 'home' })">Findprotemplates.com</router-link>
            </template>
            <template #email>
              <a :href="'mailto:' + companyEmail" class="rules__link">{{ companyEmail }}</a>
            </template>
            <template #companyName>
              <span>{{ companyName }}</span>
            </template>
            <template #companyAddress>
              <span>{{ companyAddress }}</span>
            </template>
            <template #companyNumber>
              <span>{{ companyNumber }}</span>
            </template>
          </i18n-t>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
import UiTitle from "@/components/ui/ui-title.vue";
import {useI18n} from "vue-i18n";
import DocsNavigation from "@/components/docs/docs-navigation.vue";
import en from '@/locales/en-gb.json'
import {computed, nextTick, onMounted, onUnmounted, ref} from "vue";
import translations from "@/core/helpers/translations.js";
import {useCompanyStore} from "@/stores/company.js";

const {t} = useI18n()
const companyStore = useCompanyStore()

const terms = ref(en.docs.terms.content)

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})
const companyAddress = computed(() => {
  return company.value?.companyAddress || '';
});

const companyName = computed(() => {
  if (!company.value?.companyName) return '';
  return company.value?.companyName.split('|')[0].trim();
});
const companyNumber = computed(() => {
  if (!company.value?.companyName) return '';
  return company.value?.companyName.split('|')[1].trim();
});
const companyEmail = computed(() => {
  return company.value?.emailFrom || '';
});

const navRef = ref(null);
const scrollbarRef = ref(null);
const sectionsRef = ref([]);

const navigationList = [
  {
    id: 0,
    text: 'docs.terms.nav.item1'
  },
  {
    id: 1,
    text: 'docs.terms.nav.item2'
  },
  {
    id: 2,
    text: 'docs.terms.nav.item3'
  },
  {
    id: 3,
    text: 'docs.terms.nav.item4'
  },
  {
    id: 4,
    text: 'docs.terms.nav.item5'
  },
  {
    id: 5,
    text: 'docs.terms.nav.item6'
  },
  {
    id: 6,
    text: 'docs.terms.nav.item7'
  },
  {
    id: 7,
    text: 'docs.terms.nav.item8'
  },
  {
    id: 8,
    text: 'docs.terms.nav.item9'
  },
  {
    id: 9,
    text: 'docs.terms.nav.item10'
  },
  {
    id: 10,
    text: 'docs.terms.nav.item11'
  }
]

const activeSection = ref(null);

const updateSizes = () => {
  nextTick(() => {
    if (navRef.value && scrollbarRef.value) {
      const navHeight = navRef.value.$el.offsetHeight;
      scrollbarRef.value.$el.style.height = `${navHeight}px`;
    }
  });
};

const handleScroll = () => {
  if (!scrollbarRef.value) return;

  const wrapElement = scrollbarRef.value.$el.querySelector('.el-scrollbar__wrap');
  if (!wrapElement) return;

  const scrollTop = wrapElement.scrollTop;
  const scrollPosition = scrollTop + 50;

  if (!sectionsRef.value.length) return;

  for (let i = 0; i < sectionsRef.value.length; i++) {
    const section = sectionsRef.value[i];
    if (!section) continue;

    const top = section.offsetTop;
    const height = section.offsetHeight;

    if (scrollPosition >= top && scrollPosition < top + height) {
      activeSection.value = i;
      break;
    }
  }
};

const scrollToSection = (id) => {
  if (!scrollbarRef.value || !sectionsRef.value[id]) return;

  const targetTop = sectionsRef.value[id].offsetTop;

  const wrapElement = scrollbarRef.value.$el.querySelector('.el-scrollbar__wrap');
  if (!wrapElement) return;

  wrapElement.scrollTo({
    top: targetTop - 30,
    behavior: 'smooth'
  });

  activeSection.value = id;
};

onMounted(() => {
  updateSizes();
  window.addEventListener('resize', updateSizes);

  nextTick(() => {
    handleScroll();
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', updateSizes);
});
</script>

<style lang="scss" scoped>
.docs {
  top: -103px;
  margin-bottom: -110px;

  &__wrapper {
    display: flex;
    align-items: flex-start;
  }

  &__main {
    width: 100%;
    background-color: $white;
    padding: 30px 40px;
    position: relative;
    overflow-y: auto;

    &-block {
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &-text {
      color: $black;
      font-family: Syne, sans-serif;
      font-size: 16px;
      font-weight: 700;

      & a {
        transition: 0.2s;
          color: #49123f;

        &:hover {
          color: #772668;
        }
      }
    }

    &-title {
      font-family: Syne, sans-serif;
      font-size: 30px;
      font-weight: 700;
      background: linear-gradient(90deg, #FF85FD 0.5%, #7D045A 44.83%, #3D2B44 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

ul {
  padding-left: 30px;
}

@media (max-width: 800px) {
  .docs__main {
    height: auto !important;
  }
}
</style>